// window.bootstrap = require('bootstrap');

jQuery(document).ready(function ($) {
  if ($(".modal-message").length > 0) {
    $(window).on("load", function () {
      $(".modal-message").modal("show");
    });
  }
});

(function () {
  glider1();
  glider3();
  glider4();
  glider5();
})();

// Adding class to nav on scroll
function navAnimation() {
  const fixedNacCheck = document.querySelector('.fixed-nav');

  if (fixedNacCheck) {
    let scrollPosition = window.scrollY;
    let navWrapper = document.querySelector('.navbar-wrapper');
    scrollPosition = window.scrollY;
    if (scrollPosition >= 30) {
      navWrapper.classList.add('is-visible');
    } else {
      navWrapper.classList.remove('is-visible');
    }
  }
}

/*
- Load testimonial Glider slider
@source: https://github.com/NickPiscitelli/Glider.js
*/
function glider1() {
  const gliderCheck = document.querySelector('.glider-1');

  if (gliderCheck) {
    new Glider(document.querySelector('.glider-1'), {
      slidesToShow: 1,
      slidesToScroll: 1, 
      scrollLock: true,
      draggable: true,
      rewind: true,
      dots: '.glider-1-dots',
      arrows: {
          prev: '.glider-1-prev',
          next: '.glider-1-next'
      }
    });
  }
}

function glider3() {
  const gliderCheck = document.querySelector('.glider-3');

  if (gliderCheck) {
    new Glider(document.querySelector('.glider-3'), {
      slidesToShow: 'auto',
      slidesToScroll: 3, 
      itemWidth: 350,
      scrollLock: true,
      draggable: true,
      rewind: true,
      dots: '.glider-3-dots',
      arrows: {
          prev: '.glider-3-prev',
          next: '.glider-3-next'
      }
    });
  }
}

function glider4() {
  const gliderCheck = document.querySelector('.glider-4');

  if (gliderCheck) {
    new Glider(document.querySelector('.glider-4'), {
      slidesToShow: 'auto',
      slidesToScroll: 4, 
      itemWidth: 270,
      scrollLock: true,
      draggable: true,
      rewind: true,
      dots: '.glider-dots',
      arrows: {
          prev: '.glider-prev',
          next: '.glider-next'
      }
    });
  }
}

function glider5() {
  const gliderCheck = document.querySelector('.glider-5');

  if (gliderCheck) {
    new Glider(document.querySelector('.glider-5'), {
      slidesToShow: 'auto',
      slidesToScroll: 5, 
      itemWidth: 240,
      scrollLock: true,
      draggable: true,
      rewind: true,
      dots: '.glider-5-dots',
      arrows: {
          prev: '.glider-5-prev',
          next: '.glider-5-next'
      },
      responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 5
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4
            }
          },
          {
            breakpoint: 375,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }
        ]
    });
  }
}

const faders = document.querySelectorAll(".fade-in");
const sliders = document.querySelectorAll(".slide-in");

const appearOptions = {
  threshold: 0,
  rootMargin: "0px 0px -300px 0px"
};

const appearOnScroll = new IntersectionObserver(function(
  entries,
  appearOnScroll
) {
  entries.forEach(entry => {
    if (!entry.isIntersecting) {
      return;
    } else {
      entry.target.classList.add("appear");
      appearOnScroll.unobserve(entry.target);
    }
  });
},
appearOptions);

faders.forEach(fader => {
  appearOnScroll.observe(fader);
});

sliders.forEach(slider => {
  appearOnScroll.observe(slider);
});


// Event listeners
window.addEventListener('scroll', navAnimation);
